import { colors } from '../constants';
const styleOverrides = {
  root: {
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    borderRadius: 24,
    'label + &': {
      marginTop: 15
    },
    backgroundColor: colors.oriGrey[100],
    '&:hover': {
      backgroundColor: colors.oriGrey[100]
    },
    '&.Mui-focused': {
      backgroundColor: colors.oriGrey[100]
    }
  },
  input: {
    padding: '14px 17px'
  },
  inputSizeSmall: {
    paddingTop: 6,
    paddingBottom: 6
  },
  adornedStart: {
    '& .MuiInputBase-input': {
      paddingLeft: 0
    }
  },
  adornedEnd: {
    '& .MuiInputBase-input': {
      paddingRight: 0
    }
  },
  multiline: {
    '&.Mui-sizeSmall': {
      paddingTop: 6,
      paddingBottom: 6
    },
    padding: '14px 15px'
  }
};
const defaultProps = {
  disableUnderline: true
};
export default {
  defaultProps,
  styleOverrides
};